import React from 'react'
import './footer.css'
import logo from '../../assets/imgs/logo/logo.jpg'
import LocationOnIcon from '@mui/icons-material/LocationOn';
import PhoneIcon from '@mui/icons-material/Phone';
import MailIcon from '@mui/icons-material/Mail';

export default function Footer() {
  return (
    <>
    <div style={{
        backgroundColor: 'rgb(217 217 217)',
        textAlign: 'center'
    }}>
        <div className='footer'>
        <div className="sub-footer">
            <img src={logo} alt="logo" />
            <div className="vertical-items">
                <div className="items">
                    <LocationOnIcon className='icons'/> Location
                </div>
                <div className="items">
                    <PhoneIcon className='icons'/> +91 1234567890
                </div>
                <div className="items">
                    <MailIcon className='icons'/> syncverse@hotmail.com
                </div>
            </div>
            <div className="horizontal-items">
                <div className="icon">
                    <i class="fa-brands fa-facebook" style={{color:'#3b59b6'}}></i>
                </div>
                <div className="icon">
                    <i class="fa-brands fa-square-instagram" style={{color:'rgb(154 3 212)'}}></i>
                </div>
                <div className="icon">
                    <i class="fa-brands fa-square-twitter" style={{color:'rgb(3 169 244)'}}></i>
                </div>
                <div className="icon">
                    <i class="fa-brands fa-linkedin" style={{color:'rgb(0 122 185)'}}></i>
                </div>
            </div>
        </div>
        <div className="sub-footer">
            <div className="footer-heading">
                <h2>Quick Links</h2>
            </div>
            <div className="vertical-items">
                <div className="items" >Home</div>
                <div className="items" >Products</div>
                <div className="items" >About</div>
                <div className="items" >Support</div>
                <div className="items" >Blogs</div>
            </div>
        </div>
        <div className="sub-footer">
            <div className="footer-heading">
                <h2>Company</h2>
            </div>
            <div className="vertical-items">
                <div className="items" >About Us</div>
                <div className="items" >Customers</div>
                <div className="items" >Blog</div>
                <div className="items" >Partenerships</div>
                <div className="items" >Careers</div>
            </div>
            </div>
        <div className="sub-footer">
            <div className="footer-heading">
                <h2>Product</h2>
            </div>
            <div className="vertical-items">
                <div className="items" >Features</div>
                <div className="items" >Agencies</div>
                <div className="items" >Security Audits</div>
                <div className="items" >FAQ's</div>
                <div className="items" >Help</div>
            </div>
        </div>
        <div className="sub-footer">
            <div className="footer-heading">
                <h2>Subscribe</h2>
            </div>
            <div className="vertical-items">
                <div className="input">
                    <input type="text" className="footer-field" placeholder='Name'/>
                </div>
                <div className="input">
                    <input type="text" className="footer-field" placeholder='Mail Id'/>
                </div>
                <div className="input">
                    <input type="button" value='Submit' />
                </div>
            </div>
        </div>
        </div>
        <hr />
        <div className="copyright">
            &#169; Sync Verse. All rights reserved
        </div>
    </div>
    </>
  )
}
